'use strict';

angular.module('ClinicApp').controller('ModalGenericYesNo', function($scope, $modalInstance, content) {
  $scope.content = content;

  $scope.yes = function() {
    $modalInstance.close(true);
  };

  $scope.no = function() {
    $modalInstance.dismiss('cancel');
  };
});
